import { Routes, Route, NavLink, Navigate } from "react-router-dom";
import { LayoutDashboard, FolderTree, Package, Image, Cloud, ArrowLeft } from "lucide-react";
import { useAuth } from "../../context/AuthContext";
import Dashboard from "./Dashboard";
import Categories from "./Categories";
import Products from "./Products";
import MediaManager from "./MediaManager";
import Settings from "./Settings";
import "./builder.css";

const NAV = [
  { to: "/builder", label: "Dashboard", icon: LayoutDashboard, end: true, testid: "nav-dashboard" },
  { to: "/builder/categories", label: "Categories", icon: FolderTree, testid: "nav-categories" },
  { to: "/builder/products", label: "Products", icon: Package, testid: "nav-products" },
  { to: "/builder/media", label: "Media Manager", icon: Image, testid: "nav-media" },
  { to: "/builder/settings", label: "Settings", icon: Cloud, testid: "nav-settings" },
];

export default function BuilderApp() {
  const { isAuthenticated, isAdmin, loading } = useAuth();

  if (loading) return null;
  if (!isAuthenticated || !isAdmin) return <Navigate to="/admin" replace />;

  return (
    <div className="aijb-root" data-testid="builder-root">
      <div className="app-shell">
        <aside className="sidebar" data-testid="sidebar">
          <div className="brand">Ai Joomla<span>Builder</span></div>
          <nav>
            {NAV.map((n) => (
              <NavLink key={n.to} to={n.to} end={n.end}
                className={({ isActive }) => `nav-item ${isActive ? "active" : ""}`}
                data-testid={n.testid}>
                <n.icon size={18} /> {n.label}
              </NavLink>
            ))}
          </nav>
          <NavLink to="/admin" className="nav-item" style={{ marginTop: 24, opacity: 0.7 }} data-testid="builder-exit-admin">
            <ArrowLeft size={18} /> Exit to Admin
          </NavLink>
        </aside>
        <main className="content">
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="categories" element={<Categories />} />
            <Route path="products" element={<Products />} />
            <Route path="media" element={<MediaManager />} />
            <Route path="settings" element={<Settings />} />
          </Routes>
        </main>
      </div>
    </div>
  );
}
